module.exports = __webpack_public_path__ + "static/content-wordpress-3-72486ddb9d39f2f7a59da5a3dd2d9af7.jpg";